/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ITilesContainerData } from './tiles-container.data';
import { ITilesContainerProps } from './tiles-container.props.autogenerated';

export interface ITilesContainerViewProps extends ITilesContainerProps<ITilesContainerData> {}

/**
 *
 * TilesContainer component
 * @extends {React.PureComponent<ITilesContainerProps<ITilesContainerData>>}
 */
class TilesContainer extends React.PureComponent<ITilesContainerProps<ITilesContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default TilesContainer;
